module.exports = __webpack_public_path__ + "eb8bb336f96391c158e3327d6bae2e89.svg";